{
  "auth": {
    "agree": "我同意",
    "createAccount": "创建账号",
    "createNewAccount": "创建新账号",
    "username": "用户名",
    "email": "账号",
    "login": "登录",
    "password": "密码",
    "old_password": "旧密码",
    "new_password": "新密码",
    "repeat_new_password": "重复新密码",
    "recover_password": "恢复密码",
    "update_password": "更新密码",
    "at_least_8_long": "长度至少8个字符",
    "at_least_6_unique": "至少包含6个不同的字符",
    "passwords_do_not_match": "密码不匹配",
    "sign_up": "注册",
    "keep_logged_in": "保持登录",
    "termsOfUse": "使用条款",
    "reset_password": "重置密码",
    "open_dashboard": "打开仪表板",
    "welcome": "欢迎使用",
    "error_401": "用户名或密码有误"
  },
  "404": {
    "title": "此页面已去钓鱼",
    "text": "如果您觉得这不对，请给我们发送消息",
    "back_button": "返回仪表板"
  },
  "form": {
    "must": "此项必填",
    "valid_email": "请输入一个有效的账号"
  },
  "typography": {
    "primary": "主要文本样式",
    "secondary": "次要文本样式"
  },
  "dashboard": {
    "versions": "版本",
    "home": "主页",
    "member_since": "注册时间",
    "setupRemoteConnections": "设置远程连接",
    "currentVisitors": "当前访问者",
    "charts": {
      "trendyTrends": "流行趋势",
      "showInMoreDetail": "显示更多细节",
      "showInLessDetail": "显示较少细节",
      "loadingSpeed": "加载速度",
      "topContributors": "主要贡献者",
      "showNextFive": "显示接下来的五个",
      "commits": "提交"
    },
    "info": {
      "componentRichTheme": "组件丰富的主题",
      "completedPullRequests": "已完成的拉取请求",
      "users": "用户",
      "points": "点数",
      "units": "单位",
      "exploreGallery": "探索画廊",
      "viewLibrary": "查看库",
      "commits": "提交",
      "components": "组件",
      "teamMembers": "团队成员"
    },
    "tabs": {
      "overview": {
        "title": "概述",
        "built": "使用 Vue.js 框架构建",
        "free": "对所有人完全免费",
        "fresh": "新鲜和清新的设计",
        "mobile": "响应式且优化移动",
        "components": "大量有用的组件",
        "nojQuery": "完全不使用 jQuery"
      },
      "billingAddress": {
        "title": "账单地址",
        "personalInfo": "个人信息",
        "firstName": "名字 & 姓氏",
        "email": "电子邮箱",
        "address": "地址",
        "companyInfo": "公司信息",
        "city": "城市",
        "country": "国家",
        "infiniteConnections": "无限连接",
        "addConnection": "添加连接"
      },
      "bankDetails": {
        "title": "银行详情",
        "detailsFields": "详情字段",
        "bankName": "银行名称",
        "accountName": "账户名称",
        "sortCode": "排序代码",
        "accountNumber": "账号",
        "notes": "备注",
        "sendDetails": "发送详情"
      }
    },
    "navigationLayout": "导航布局",
    "topBarButton": "顶部按钮",
    "sideBarButton": "侧边按钮"
  },
  "language": {
    "brazilian_portuguese": "葡萄牙语",
    "english": "英语",
    "spanish": "西班牙语",
    "simplified_chinese": "简体中文",
    "persian": "波斯语"
  },
  "menu": {
    "auth": "授权",
    "buttons": "按钮",
    "timelines": "时间线",
    "dashboard": "仪表板",
    "billing": "计费",
    "login": "登录",
    "signUp": "注册",
    "payments": "支付",
    "payment-methods": "支付方式",
    "pricing-plans": "定价计划",
    "login-singup": "登录/注册",
    "404": "404 页面",
    "faq": "常见问题解答",
    "user_panel": "用户面板",
    "admin_panel": "管理面板",
    "overview": "使用概览",
    "experiment_design": "实验设计",
    "admin_experiment_design": "实验设计管理",
    "users": "用户管理",
    "quartet": "Quartet",
    "plasmix": "Plasmix",
    "dna": "基因组",
    "rna": "转录组",
    "protein": "蛋白组",
    "metabolism": "代谢组",
    "plasmix_protein": "蛋白组",
    "plasmix_metabolism": "代谢组"
  },
  "design": {
    "project_name": "项目名称",
    "sample_type": "样本类型",
    "sample_count": "临床样本数",
    "omics_type": "组学类型",
    "reference_count": "标品数量",
    "reference_type": "标品类型",
    "created_at": "提交时间",
    "status": "状态",
    "submitted": "待确认",
    "cancelled": "已取消",
    "confirmed": "已确认"
  },
  "omics": {
    "add_item": "添加",
    "get_report": "获取报告",
    "download": "下载",
    "uploading": "上传中",
    "cancel": "取消",
    "save": "保存",
    "add": "添加",
    "upload_hint": "请先上传原始文件至",
    "aliyun": "阿里云",
    "upload_hint_2": "，再添加或修改。",
    "aliyun_path": "OSS路径",
    "download_report": "下载质量评估报告",
    "confirm_download": "确认生成并下载质量评估报告么？请知悉: 生成报告需要几秒钟的时间。",
    "confirm_download_with_name": "确认生成并下载 {name} 的质量评估报告么？ 请知悉: 生成报告需要几秒钟的时间。",
    "confirm_form_change_disregard": "有未保存的更改，确认取消么？",
    "csv_only": "只接受.csv格式文件",
    "refer_sample": "点此查看示例",
    "qc_result": "质评结果",
    "filter_by_user": "按用户筛选",
    "notes": "备注",
    "update_notes": "更新备注",
    "confirm_update_notes": "您确定要更新 {name} 的备注么？",
    "download_raw_data": "下载原始数据",
    "confirm_download_raw_data": "您确定要下载 {name} 的原始数据 {file} 么？",
    "sample_number": "标准品数量",
    "created_at": "提交时间",
    "yes": "是",
    "no": "否",
    "pass": "通过质检",
    "fail": "质检失败"
  },
  "dna": {
    "edit_data": "编辑基因组数据",
    "add_data": "添加基因组数据",
    "view_data": "查看基因组数据",
    "name": "名称",
    "name_placeholder": "格式：批次号_其他描述性信息",
    "sample_id": "样本编号",
    "family": "样本类别",
    "platform_model": "测序平台与型号",
    "dna_fragmentation": "打断方法",
    "library_protocol": "文库构建协议",
    "application": "检测应用类型",
    "read_mode": "读段模式",
    "reference": "参考基因组版本",
    "alignment_software": "比对软件",
    "variant_caller": "变异检测软件",
    "filtering": "变异过滤策略",
    "determinated_at": "测序时间",
    "vcf_file": "VCF文件",
    "d5": "D5(双胞胎女儿1号)",
    "d6": "D6(双胞胎女儿2号)",
    "f7": "F7(父亲)",
    "m8": "M8(母亲)",
    "acoustic_shear": "超声物理打断",
    "enzymatic": "酶切打断",
    "transposase": "转座酶切割/Tn5",
    "no_fragmentation": "长片段测序不打断",
    "pcr_free": "无扩增",
    "pcr_based": "常规扩增",
    "hybrid_capture": "杂交捕获",
    "wgs": "全基因组",
    "wes": "全外显子",
    "targeted_panel": "靶向测序",
    "low_pass_wgs": "低深度全基因组",
    "status": "状态",
    "processing": "计算中",
    "done": "已完成",
    "select_hint": "已选条目(单击反选)",
    "upload_hint": "优先计算VCF文件，如果不合格，会自动计算FASTQ文件。大概需要花费数小时进行分析，相应报告可在分析完成后下载。",
    "vcf_only": "只接受.vcf和.vcf.gz两种格式文件，需要同时包含SNP和INDEL标记信息，对SV标记信息目前不在评判范围内",
    "fq_only": "只接受.fq.gz格式文件",
    "plz_select": "请选择",
    "uploading": "待上传",
    "uploaded": "已上传",
    "upload_failure": "上传失败，请刷新网页后选择继续上传",
    "vcf_pass": "VCF质检通过",
    "download_vcf": "下载VCF文件",
    "confirm_download": "您确定要下载VCF文件({file})吗？",
    "update_score": "更新评分",
    "confirm_update_score": "您确定要更新 {name} 的评分吗？"
  },
  "rna": {
    "edit_data": "编辑转录组数据",
    "add_data": "添加转录组数据",
    "view_data": "查看转录组数据",
    "name": "名称",
    "sample_id": "样本编号",
    "platform_model": "测序平台与型号",
    "rna_fragmentation": "RNA打断方法",
    "enrichment": "RNA富集/选择方法",
    "library_protocol": "文库构建协议",
    "read_mode": "测序读段模式",
    "reference": "参考基因组与注释版本",
    "alignment_software": "比对软件",
    "quantification_tool": "表达定量工具",
    "expression_unit": "表达量单位",
    "determinated_at": "测序时间",
    "meta_file": "元数据文件",
    "exp_file": "表达矩阵文件",
    "count_file": "表达量文件",
    "acoustic_shear": "超声物理打断",
    "enzymatic": "酶切打断",
    "chemical": "Mg2+高温化学打断",
    "no_fragmentation": "长读长不打断",
    "ribosomal_depletion": "核糖体去除",
    "polyA_selection": "聚腺苷酸选择",
    "total_rna": "全RNA",
    "globin_depletion": "珠蛋白去除",
    "targeted_capture": "靶向捕获"
  },
  "protein": {
    "edit_data": "编辑蛋白组数据",
    "add_data": "添加蛋白组数据",
    "view_data": "查看蛋白组数据",
    "name": "名称",
    "ms_instrument": "质谱仪厂家与型号",
    "acquisition_method": "进样策略/采集模式",
    "lc_system": "液相色谱系统",
    "lc_column": "色谱柱类型",
    "fractionation": "分级方法",
    "digestion_enzyme": "消化酶",
    "analysis_software": "搜库/定量软件",
    "database": "蛋白质数据库",
    "normalization": "表达量归一化方法",
    "determinated_at": "测定时间",
    "meta_file": "元数据文件",
    "exp_file": "表达矩阵文件",
    "no_fractionation": "直接进样",
    "high_ph_reverse_phase": "高pH反相分级",
    "scx": "强阳离子交",
    "gelc_ms": "胶上切带"
  },
  "metabolism": {
    "edit_data": "编辑代谢组数据",
    "add_data": "添加代谢组数据",
    "view_data": "查看代谢组数据",
    "name": "名称",
    "ms_instrument": "质谱仪型号",
    "detection_strategy": "检测策略",
    "analysis_platform": "分析平台",
    "chromatography": "色谱类型",
    "ionization": "离子源与极性",
    "extraction_method": "提取溶剂/方法",
    "preprocessing_software": "原始数据处理软件",
    "identification_level": "代谢物鉴定依据",
    "unit": "表达量单位与归一化",
    "database": "代谢组数据库",
    "determinated_at": "测定时间",
    "meta_file": "元数据文件",
    "exp_file": "表达矩阵文件",
    "untargeted": "非靶向",
    "targeted": "靶向定值",
    "semi_targeted": "半靶向",
    "lipidomics": "脂质组学",
    "lc_ms": "液质联用",
    "gc_ms": "气质联用",
    "nmr": "核磁共振",
    "ce_ms": "电泳质联用",
    "di_ms": "直接进样质谱",
    "reverse_phase": "反相",
    "hilic": "亲水相互作用",
    "normal_phase": "正相",
    "gc_capillary_column": "气相毛细管柱",
    "ion_exchange": "离子交换",
    "esi_positive": "电喷雾正离子",
    "esi_negative": "电喷雾负离子",
    "apci": "APCI",
    "ei": "电子轰击源",
    "name_version": "数据库名称+版本号"
  },
  "plasmix_protein": {
    "edit_data": "编辑蛋白组数据",
    "add_data": "添加蛋白组数据",
    "view_data": "查看蛋白组组数据",
    "name": "名称",
    "technology": "检测技术平台",
    "model_panel": "具体型号/产品线",
    "pre_treatment": "血浆前处理/富集",
    "readout": "测序/读数终端",
    "protocol": "文库/消化方案",
    "expression_unit": "表达数据单位",
    "analysis_software": "分析/搜库软件",
    "database": "参考数据库",
    "normalization": "归一化/质控策略",
    "determinated_at": "测定时间",
    "meta_file": "元数据文件",
    "exp_file": "表达矩阵文件",
    "neat_plasma": "原始直检",
    "high_abundance_depletion": "去高丰度",
    "nanoparticle_enrichment": "纳米颗粒富集",
    "proximity_extension": "PEA原位杂交",
    "aptamer_capture": "适配体捕获"
  },
  "plasmix_metabolism": {
    "edit_data": "编辑代谢组数据",
    "add_data": "添加代谢组数据",
    "view_data": "查看代谢组数据",
    "name": "名称",
    "ms_instrument": "质谱仪型号",
    "detection_strategy": "检测策略",
    "analysis_platform": "检测技术平台",
    "chromatography": "色谱分离模式",
    "ionization": "离子源与极性",
    "extraction_method": "提取溶剂/方法",
    "preprocessing_software": "原始数据处理软件",
    "normalization": "归一化方法",
    "identification_basis": "代谢物鉴定依据",
    "database": "代谢组数据库",
    "determinated_at": "测定时间",
    "meta_file": "元数据文件",
    "exp_file": "表达矩阵文件",
    "untargeted": "非靶向/发现代谢组",
    "targeted": "靶向/定量代谢组",
    "polar_metabolites": "极性代谢物",
    "lipidomics": "脂质组学",
    "lc_ms": "液质联用",
    "gc_ms": "气质联用",
    "nmr": "核磁共振",
    "di_ms": "直接进样质谱",
    "reverse_phase": "反相",
    "hilic": "亲水相互作用",
    "normal_phase": "正相",
    "gc_capillary_column": "气相色谱柱",
    "biphasic": "双相/混合模式",
    "esi_positive": "电喷雾正离子",
    "esi_negative": "电喷雾负离子",
    "apci": "APCI",
    "ei": "电子轰击源",
    "dual_polarity": "正负切换",
    "name_version": "数据库名称+版本号"
  },
  "messages": {
    "all": "查看所有消息",
    "new": "来自 {name} 的新消息",
    "mark_as_read": "标记为已读"
  },
  "navbar": {
    "messageUs": "需要Web开发帮助吗？请联系我们。",
    "repository": "GitHub 仓库"
  },
  "notifications": {
    "all": "查看所有通知",
    "mark_as_read": "标为已读",
    "sentMessage": "{name} 给你发了一条消息",
    "uploadedZip": "{name} 上传了一个新的 Zip 文件 {type}",
    "startedTopic": "{name} 开始了一个新话题"
  },
  "user": {
    "language": "语言",
    "logout": "登出",
    "profile": "我的资料",
    "settings": "设置",
    "theme": "主题",
    "preferences": "偏好设置",
    "billing": "账单",
    "faq": "常见问题",
    "helpAndSupport": "帮助与支持",
    "projects": "项目",
    "account": "账户",
    "explore": "探索",
    "active": "启用",
    "inactive": "停用",
    "role": "角色",
    "notes": "备注",
    "add_user": "添加用户",
    "edit_user": "编辑用户",
    "save": "保存",
    "add": "添加",
    "leave_empty_unchanged": "不修改请留空",
    "confirm_form_change_disregard": "有未保存的更改，确认取消么？",
    "confirm_enable_access_key": "确认启用阿里云账号？",
    "confirm_disable_access_key": "确认关闭阿里云账号？"
  },
  "treeView": {
    "basic": "基本型",
    "icons": "图标",
    "selectable": "可选择",
    "editable": "可编辑",
    "advanced": "高级"
  },
  "chat": {
    "title": "聊天"
  },
  "cards": {
    "cards": "卡片",
    "fixed": "固定的",
    "floating": "浮动的",
    "contentText": "独特的斑马条纹使它们成为人们最熟悉的动物之一。",
    "rowHeight": "行高",
    "title": {
      "dark": "暗色背景",
      "bright": "亮色卡片",
      "titleOnImageNoOverlay": "图像上的标题，但没有叠加",
      "normal": "标准卡",
      "overlayAndTextOnImage": "图像上有覆盖和文本的卡片",
      "stripeNoImage": "无图像条纹卡"
    },
    "button": {
      "main": "主要",
      "cancel": "取消"
    },
    "link": {
      "edit": "编辑",
      "setAsDefault": "设为默认",
      "delete": "删除",
      "traveling": "Traveling",
      "france": "法国",
      "review": "评论",
      "feedback": "反馈信息",
      "readFull": "阅读全文",
      "secondaryAction": "第二行为",
      "action1": "行为 1",
      "action2": "行为 2"
    }
  },
  "helpAndSupport": "帮助与支持",
  "aboutVuesticAdmin": "关于 Vuestic Admin",
  "search": {
    "placeholder": "搜索或添加一个新选项"
  },
  "buttonSelect": {
    "dark": "深色",
    "light": "浅色"
  },
  "vuestic": {
    "search": "搜索",
    "noOptions": "未找到项目",
    "ok": "确认",
    "cancel": "取消",
    "uploadFile": "上传文件",
    "undo": "撤销",
    "dropzone": "将文件拖到此处上传",
    "fileDeleted": "文件已删除",
    "closeAlert": "关闭警告",
    "backToTop": "回到顶部",
    "toggleDropdown": "切换下拉菜单",
    "carousel": "轮播",
    "goPreviousSlide": "上一张幻灯片",
    "goNextSlide": "下一张幻灯片",
    "goSlide": "跳转到第 {index} 张幻灯片",
    "slideOf": "第 {index} 张，共 {length} 张",
    "close": "关闭",
    "openColorPicker": "打开颜色选择器",
    "colorSelection": "颜色选择",
    "colorName": "颜色 {color}",
    "decreaseCounter": "减少计数",
    "increaseCounter": "增加计数",
    "selectAllRows": "选择所有行",
    "sortColumnBy": "按 {name} 排序",
    "selectRowByIndex": "选择第 {index} 行",
    "resetDate": "重置日期",
    "nextPeriod": "下一个时间段",
    "switchView": "切换视图",
    "previousPeriod": "上一个时间段",
    "removeFile": "删除文件",
    "reset": "重置",
    "pagination": "分页",
    "goToTheFirstPage": "跳转到第一页",
    "goToPreviousPage": "跳转到上一页",
    "goToSpecificPage": "跳转到第 {page} 页",
    "goToSpecificPageInput": "输入页码以跳转",
    "goNextPage": "跳转到下一页",
    "goLastPage": "跳转到最后一页",
    "currentRating": "当前评分 {value} / {max}",
    "voteRating": "评分 {value} / {max}",
    "optionsFilter": "选项筛选",
    "splitPanels": "分割面板",
    "movePaginationLeft": "分页向左移动",
    "movePaginationRight": "分页向右移动",
    "resetTime": "重置时间",
    "closeToast": "关闭提示",
    "selectedOption": "已选选项",
    "noSelectedOption": "未选择选项",
    "breadcrumbs": "面包屑导航",
    "counterValue": "计数值",
    "selectedDate": "选择的日期",
    "selectedTime": "选择的时间",
    "progressState": "进度状态",
    "color": "颜色",
    "next": "下一步",
    "back": "上一步",
    "finish": "完成",
    "step": "步骤",
    "progress": "进度",
    "loading": "加载中",
    "sliderValue": "当前滑块值为 {value}",
    "switch": "切换",
    "inputField": "输入框",
    "fileTypeIncorrect": "文件类型不正确",
    "select": "选择一个选项",
    "no_items": "无条目",
    "total_results": "共 {value} 条",
    "results_per_page": "每页条数"
  }
}
